module.exports = __webpack_public_path__ + "img/roaring_rabbit_256.e1446d19.png";